import { Box, Button, Grid, Menu, MenuItem, Typography, IconButton, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { format } from "date-fns";
import { driverLeaveApis } from "../../../Data/axios";
import PhoneIcon from "@mui/icons-material/Phone";
import StatusAlert from "../../../StatusAlertList/StatusAlert";

const ViewMoreJobsApp = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openMenuId, setOpenMenuId] = useState(null);
  const openDropMenu = Boolean(anchorEl);
  const navigate = useNavigate();
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");
  const [calling, setCalling] = useState({ driver: false, client: false });

  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const location = useLocation();
  const rowData = location.state;

  const {
    id,
    created_at,
    driver_id,
    owner_id,
    start_date,
    end_date,
    type,
    reason,
    status,
    approved_by,
    approved_at,
    file,
    note,
  } = rowData || {};
  const date = new Date(created_at);
  const day = String(date.getDate()).padStart(2, "0"); // Adds leading zero if necessary
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed, so add 1
  const year = date.getFullYear();
  const formattedDate = `${day}-${month}-${year}`;

  const handleOpenMenu = (id) => {
    setOpenMenuId(id);
  };
  const formattedLeaveDate = (date) => format(new Date(date), "dd-MM-yyyy");
  const convertToPlainText = (htmlContent) => {
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(htmlContent, "text/html");
    return parsedHtml.body.textContent || "";
  };
  const convertToUserType = (value) => {
    if (value === "1") return "Client";
    if (value === "2") return "Employee";
    if (value === "3") return "App User";
    return "Unknown"; // Fallback for invalid values
  };
  const approvedType = (value) => {
    if (value === "0") return "Rejected";
    if (value === "2") return "Approved";

    return "Unknown"; // Fallback for invalid values
  };

  const handleCall = async (phoneNumber, type) => {
    if (!phoneNumber) {
      showAlert("Phone number not available", "error");
      return;
    }

    setCalling(prev => ({ ...prev, [type]: true }));

    try {
      const response = await driverLeaveApis.callUsers(phoneNumber);

      if (response.success) {
        showAlert("Call initiated successfully", "success");
      } else {
        showAlert(response.message || "Failed to initiate call", "error");
      }
    } catch (error) {
      console.error("Call initiation error:", error);
      showAlert("Failed to initiate call. Please try again.", "error");
    } finally {
      setCalling(prev => ({ ...prev, [type]: false }));
    }
  };

  return (
    <>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />
      <Box
        sx={{
          color: "#333",
          padding: "20px",
          fontSize: "20px",
          fontWeight: 550,
        }}
      >
      <Box sx={{ color: "#333", bgcolor: "#fff", height: "100vh" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgb(187, 186, 186) ",
          }}
        >
          <Box sx={{ padding: "20px" }}>Job Applicant Details</Box>
        </Box>
        <Box>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Driver's Name
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  variant="body1"
                  sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
                >
                  {""}
                  <br />
                  {driver_id || ""}
                </Typography>
                {driver_id && (
                  <IconButton
                    size="small"
                    onClick={() => handleCall(typeof driver_id === 'object' ? driver_id.mobile : '', 'driver')}
                    disabled={calling.driver}
                    sx={{
                      color: "#2196f3",
                      "&:hover": { backgroundColor: "rgba(33, 150, 243, 0.1)" }
                    }}
                  >
                    {calling.driver ? <CircularProgress size={20} /> : <PhoneIcon />}
                  </IconButton>
                )}
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Client's Name
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography
                  variant="body1"
                  sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
                >
                  {""}
                  <br />
                  {owner_id || ""}
                </Typography>
                {owner_id && (
                  <IconButton
                    size="small"
                    onClick={() => handleCall(typeof owner_id === 'object' ? owner_id.mobile : '', 'client')}
                    disabled={calling.client}
                    sx={{
                      color: "#2196f3",
                      "&:hover": { backgroundColor: "rgba(33, 150, 243, 0.1)" }
                    }}
                  >
                    {calling.client ? <CircularProgress size={20} /> : <PhoneIcon />}
                  </IconButton>
                )}
              </Box>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Requested Date
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                From: {formattedLeaveDate(start_date)} ----- To:
                {formattedLeaveDate(end_date)}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Requested At
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {formattedDate || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                To
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {convertToUserType(type) || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Reason
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {reason || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Status
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {approvedType(status) || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Note
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {convertToPlainText(note) || ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                File
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {file ? (
                  <a
                    href={`https://rptpl.roadpilot.co.in/public/${file}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ cursor: "pointer" }}
                  >
                    <em>Pdf</em>
                  </a>
                ) : (
                  "No file available"
                )}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Approved By
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {approved_by || ""}
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={4}>
              <Typography
                variant="body1"
                sx={{ color: "#333", padding: "10px 20px", fontSize: "15px" }}
              >
                Approved At
              </Typography>
            </Grid>

            <Grid item xs={8}>
              <Typography
                variant="body1"
                sx={{ color: "gray", padding: "10px 0", fontSize: "15px" }}
              >
                {approved_at || ""}
              </Typography>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </Box>
    </>
  );
};

export default ViewMoreJobsApp;
